import React from "react";
import {Icon} from "@/components/Icon.tsx";

export interface ChatbotBubbleOptions {
    onClick: () => void
    opened : boolean

    position: string

    icon: string
    iconBgColor: string
    iconColor: string
    image: string
}

export const bubbleIcons: { [key: string]: any } = {
    "1": {
        name : "fluent:chat-16-regular",
        icon : <Icon icon='fluent:chat-16-regular' width="42" />
    },
    "2": {
        name : "fluent:chat-empty-24-regular",
        icon : <Icon icon='fluent:chat-empty-24-regular' width="42" />
    },
    "3": {
        name : "ci:chat",
        icon : <Icon icon='ci:chat' width="42" />
    },
    "4": {
        name : "ri:chat-2-line",
        icon : <Icon icon='ri:chat-2-line' width="42" />,
        className : "mt-1",
        width : "40"
    }
}

const ChatbotOpenBubble = (props: ChatbotBubbleOptions) => {

    if (props.image || props.icon == 'custom') {
        return (
            <div style={{
                     width: "64px",
                     height: "64px",
                     cursor: "pointer",
                     borderRadius: "50%",
                     // backgroundColor: "gray",
                     backgroundImage: `url("${props.image}")`,
                     backgroundRepeat: "no-repeat",
                     backgroundPosition: "center",
                     backgroundSize: "contain"
                 }}
                 onClick={() => {
                     props.onClick()
                 }}
            >
            </div>
        )
    }

    let icon = bubbleIcons[props.icon];

    return (
        <div onClick={() => {props.onClick()}}>
            <div className="wz-bubble wz-bubble-icon" style={{
                backgroundColor: props.iconBgColor,
                color: props.iconColor
            }}
            >
                <Icon className={!props.opened ? 'wz-animation-hidden' : ''} icon="fluent:dismiss-16-regular" width="24"/>
                <Icon className={icon.className + (props.opened ? ' wz-animation-hidden' : '')}
                      icon={icon.name}
                      width={icon.width ? icon.width : "42"}
                />
            </div>
        </div>
    )
}

export default ChatbotOpenBubble;